const getters = {
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  status: state => state.user.status,
  token: state => state.user.token,
  partnerId: state => state.user.partnerId,
  partnerType: state => state.user.partnerType,
  partnerName: state => state.user.partnerName,
  layoutTheme: state => state.app.layoutTheme,
  permission_routers: state => state.permission.routers,
  addRouters: state => state.permission.addRouters,
  errorLogs: state => state.errorLog.logs,
  visitedViews: state => state.tagsView.visitedViews,
}
export default getters


// WEBPACK FOOTER //
// C:/Users/xiaolan/Desktop/Android/Xrross-SOC-Frontend/E:/xrross/Android/Xrross-SOC-Frontend/src/store/getter.js